import { BREAKPOINTS } from 'resources/constants'
import styled from 'styled-components'

export const Wrapper = styled.section`
	position: relative;
	width: 100%;
	height: 100%;
	background-color: #ccbad7;
	padding: 60px 30px;

	&::before {
		content: '';
		position: absolute;
		top: 0;
		width: 0;
		height: 0;
		border-style: solid;
		border-width: 40px 60px 0 60px;
		border-color: #fff transparent transparent transparent;
		left: 50%;
		transform: translateX(-50%);
	}
`

export const TimerHeading = styled.h2`
	margin: 0 0 24px;
	text-align: center;
	color: #fff;
	font-family: 'Roboto Serif', serif;
	font-size: clamp(1.5rem, 5vw, 2rem);
`

export const CountdownContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	width: 100%;
	max-width: 720px;
	margin: 0 auto;
	flex-wrap: wrap;
`

export const CountdownWrapper = styled.div`
	flex: 1;
	display: flex;
	flex-direction: column;
	align-items: center;
	padding: 5px;
	color: rgba(255, 255, 255, 90%);
	font-family: 'Roboto Serif', serif;
	font-style: italic;
	flex-basis: 50%;

	@media only screen and (min-width: ${BREAKPOINTS.sm}) {
		flex-basis: 33.333%;
	}
`

export const CountdownText = styled.div`
	font-size: clamp(1rem, 5vw, 1.5rem);
	color: rgba(255, 255, 255, 90%);
`

export const CountdownNumber = styled.div`
	font-size: clamp(1.5rem, 10vw, 3rem);
	font-weight: 700;
`
